class UsersListContainer {
  constructor(
    $element,
    $location,
    $timeout,
    appErrorHandler,
    appEvents,
    appSectionsStorage,
    appSession,
    locationUtils,
    users,
    USERS_EVENTS,
  ) {
    'ngInject';

    [this.$element] = Array.from($element);
    this.$location = $location;
    this.$timeout = $timeout;
    this.appErrorHandler = appErrorHandler;
    this.appEvents = appEvents;
    this.locationUtils = locationUtils;
    this.USERS_EVENTS = USERS_EVENTS;
    this.shouldTriggerInitialFetch = false;
    this.mainList = appSectionsStorage.store(
      'users',
      'mainList',
      () => {
        this.shouldTriggerInitialFetch = true;
        return users.newList();
      },
    );
    this.appSession = appSession;
    this.currentUserId = '';
    this.searchList = users.newList();
    this.searchQuery = '';
    this.listsDisplayProperties = {
      label: {
        withDetail: 'name',
        withoutDetail: 'email',
      },
      detail: 'email',
      hasDetail: 'hasName',
    };
    this.listsEnabled = true;

    this.selectionRoute = '/users/';
    this.removeSelectionSubscription = this.appEvents.on(
      this.USERS_EVENTS.select,
      (user) => {
        this.selectedId = user.id;
      },
    );
    this.removeSelectionLoadSubscription = this.appEvents.on(
      this.USERS_EVENTS.load.start,
      () => this.disableLists(),
    );
    this.removeSelectionFinishSubscription = this.appEvents.on(
      this.USERS_EVENTS.load.finish,
      () => this.enableLists(),
    );
    this.removeUserUpdateSubscription = this.appEvents.on(
      this.USERS_EVENTS.edit.save,
      (user) => this.updateUserOnLists(user),
    );
    this._searchboxSelector = '[data-list-searchbox] input[type="text"]';
  }
  $onInit() {
    this.currentUserId = this.appSession.getSession().user.id;

    if (this.$location.search().refresh === 'yes') {
      this.refreshLists();
      this.$timeout(() => {
        this.$location.url(this.$location.path());
      });
    } else if (this.shouldTriggerInitialFetch) {
      this.fetchMoreFromMainList();
    }
  }
  $onDestroy() {
    this.removeSelectionSubscription();
    this.removeSelectionLoadSubscription();
    this.removeSelectionFinishSubscription();
  }
  disableLists() {
    this.listsEnabled = false;
  }
  enableLists() {
    this.listsEnabled = true;
  }
  updateUserOnLists(user) {
    this.mainList.updateUser(user);
    this.searchList.updateUser(user);
  }
  refreshLists() {
    this.mainList
    .reset()
    .fetch()
    .catch((error) => {
      this.appErrorHandler.handle(error, 'There was an error loading the users list');
    });

    if (this.searchQuery) {
      this
      .reset()
      .search(this.searchQuery, true)
      .catch((error) => {
        this.appErrorHandler.handle(error, 'There was an error loading the users list');
      });
    }
  }
  fetchMoreFromMainList() {
    return this.mainList
    .fetch()
    .catch((error) => {
      this.appErrorHandler.handle(error, 'There was an error loading the users list');
    });
  }
  fetchMoreFromSearchList() {
    return this.searchList
    .fetch(this.searchQuery)
    .catch((error) => {
      this.appErrorHandler.handle(error, 'There was an error loading the search results');
    });
  }
  search(text, force = false) {
    if (text !== this.searchQuery || force) {
      this.searchQuery = text;
      if (this.searchQuery) {
        if (force) {
          this.searchList.reset();
        }

        this.searchList.fetch(this.searchQuery)
        .then(() => this.setSearchboxFocus())
        .catch((error) => {
          this.appErrorHandler.handle(error, 'There was an error loading the search results');
        });
      }
    }
  }
  setSearchboxFocus() {
    this.$timeout(() => {
      this.$element.querySelector(this._searchboxSelector).focus();
    });
  }
  selectUser($event, item) {
    $event.preventDefault();
    if (item.id !== this.selectedId) {
      const newPath = `${this.selectionRoute}${item.id}`;
      if (this.locationUtils.path().endsWith('/activities')) {
        this.locationUtils.path(newPath);
      } else {
        this.locationUtils.skipReload().path(newPath);
      }
      this.appEvents.emit(this.USERS_EVENTS.select, item);
    }
  }
}

export default {
  controller: UsersListContainer,
  template: `
    <div class="flex-column">
      <searchbox
        id="searchFilter"
        max-length="50"
        on-search="$ctrl.search(text)"
        disable-search="($ctrl.mainList.fetching || $ctrl.searchList.fetching)"
        data-list-searchbox
      ></searchbox>
      <selection-list
        class="flex-column"
        ng-if="!$ctrl.searchQuery"
        items="$ctrl.mainList.items"
        items-display-properties="$ctrl.listsDisplayProperties"
        items-route="{{::$ctrl.selectionRoute}}"
        selected-item-id="$ctrl.selectedId"
        flagged-item-id="$ctrl.currentUserId"
        flagged-badge-value="YOU"
        total="$ctrl.mainList.total"
        loading="$ctrl.mainList.fetching"
        items-per-page="$ctrl.mainList.itemsPerPage"
        disable-selection="!$ctrl.listsEnabled"
        on-request-more-items="$ctrl.fetchMoreFromMainList()"
        on-item-selection="$ctrl.selectUser($event, item)"
      ></selection-list>
      <selection-list
        class="flex-column"
        ng-if="$ctrl.searchQuery"
        items="$ctrl.searchList.items"
        items-display-properties="$ctrl.listsDisplayProperties"
        items-route="{{::$ctrl.selectionRoute}}"
        selected-item-id="$ctrl.selectedId"
        flagged-item-id="$ctrl.currentUserId"
        flagged-badge-value="YOU"
        total="$ctrl.searchList.total"
        loading="$ctrl.searchList.fetching"
        items-per-page="$ctrl.searchList.itemsPerPage"
        disable-selection="!$ctrl.listsEnabled"
        on-request-more-items="$ctrl.fetchMoreFromSearchList()"
        custom-no-results-message="No results found"
        on-item-selection="$ctrl.selectUser($event, item)"
      ></selection-list>
    </div>
  `,
  bindings: {
    selectedId: '<',
  },
};
